import { render, staticRenderFns } from "./ChequeStudio.vue?vue&type=template&id=5522c6e4&scoped=true&"
import script from "./ChequeStudio.vue?vue&type=script&lang=js&"
export * from "./ChequeStudio.vue?vue&type=script&lang=js&"
import style0 from "./ChequeStudio.vue?vue&type=style&index=0&id=5522c6e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5522c6e4",
  null
  
)

export default component.exports